import { useEffect, useId, useMemo, useRef, useState } from "react";
import type { CSSProperties, FormEvent } from "react";
import "./index.css";

import puppyBlue from "./assets/puppy_cat_azul.png";
import puppyPink from "./assets/puppy_cat_rosa.png";
import puppyGreen from "./assets/puppt_cat_green.png";
import biancaPhoto from "./assets/bianca.jpg";
import biancaEdit from "./assets/bianca_foto_editada.png";
import biancaCat from "./assets/gatinha_da_bianca.png";
import writingAudio from "./assets/writing-with-pencil-411721.mp3";
import notificationAudio from "./assets/simple-notification-152054(1).mp3";

const particles = [
  {
    id: "p1",
    src: puppyBlue,
    size: "84px",
    left: "6%",
    top: "12%",
    duration: "18s",
    delay: "-6s",
    drift: "24px",
    rotate: "-6deg",
    opacity: 0.6,
  },
  {
    id: "p2",
    src: puppyPink,
    size: "70px",
    left: "82%",
    top: "8%",
    duration: "20s",
    delay: "-10s",
    drift: "-20px",
    rotate: "8deg",
    opacity: 0.55,
  },
  {
    id: "p3",
    src: puppyGreen,
    size: "96px",
    left: "16%",
    top: "68%",
    duration: "22s",
    delay: "-3s",
    drift: "18px",
    rotate: "4deg",
    opacity: 0.55,
  },
  {
    id: "p4",
    src: puppyBlue,
    size: "64px",
    left: "70%",
    top: "72%",
    duration: "19s",
    delay: "-8s",
    drift: "-16px",
    rotate: "-4deg",
    opacity: 0.5,
  },
  {
    id: "p5",
    src: puppyPink,
    size: "110px",
    left: "44%",
    top: "22%",
    duration: "24s",
    delay: "-12s",
    drift: "28px",
    rotate: "6deg",
    opacity: 0.45,
  },
  {
    id: "p6",
    src: puppyGreen,
    size: "72px",
    left: "30%",
    top: "40%",
    duration: "17s",
    delay: "-5s",
    drift: "-14px",
    rotate: "-8deg",
    opacity: 0.6,
  },
  {
    id: "p7",
    src: puppyBlue,
    size: "58px",
    left: "88%",
    top: "44%",
    duration: "16s",
    delay: "-2s",
    drift: "16px",
    rotate: "10deg",
    opacity: 0.5,
  },
  {
    id: "p8",
    src: puppyPink,
    size: "78px",
    left: "8%",
    top: "46%",
    duration: "21s",
    delay: "-9s",
    drift: "-18px",
    rotate: "2deg",
    opacity: 0.52,
  },
];

const floatItems = [
  {
    id: "bianca-1",
    type: "image",
    src: biancaPhoto,
    size: "140px",
    left: "6%",
    top: "18%",
    rotate: "-5deg",
    duration: "24s",
    delay: "-6s",
    variant: "is-large is-photo",
  },
  {
    id: "bianca-2",
    type: "image",
    src: biancaEdit,
    size: "120px",
    left: "82%",
    top: "14%",
    rotate: "6deg",
    duration: "22s",
    delay: "-10s",
    variant: "is-photo",
  },
  {
    id: "bianca-3",
    type: "image",
    src: biancaCat,
    size: "130px",
    left: "76%",
    top: "62%",
    rotate: "-4deg",
    duration: "26s",
    delay: "-4s",
    variant: "is-large is-photo",
  },
  {
    id: "gif-eggplant",
    type: "video",
    src: "https://media.tenor.com/gnJ-dDHiybYAAAPo/puppycat-eggplant.mp4",
    size: "90px",
    left: "14%",
    top: "66%",
    rotate: "4deg",
    duration: "18s",
    delay: "-2s",
  },
  {
    id: "gif-cat-gun",
    type: "video",
    src: "https://media.tenor.com/dhuQV_msfiUAAAPo/cat-gun.mp4",
    size: "88px",
    left: "90%",
    top: "44%",
    rotate: "-6deg",
    duration: "20s",
    delay: "-12s",
  },
  {
    id: "gif-kiss-1",
    type: "video",
    src: "https://media.tenor.com/rQDYjWeWzlgAAAPo/kitten-cats.mp4",
    size: "84px",
    left: "6%",
    top: "46%",
    rotate: "5deg",
    duration: "21s",
    delay: "-8s",
  },
  {
    id: "gif-couple",
    type: "video",
    src: "https://media.tenor.com/bZeueJS0wvsAAAPo/conswayo-cats.mp4",
    size: "86px",
    left: "70%",
    top: "40%",
    rotate: "-2deg",
    duration: "19s",
    delay: "-5s",
  },
  {
    id: "gif-kiss-2",
    type: "video",
    src: "https://images-ext-1.discordapp.net/external/wpbc4gbNZT_R9H6sGAMZ5t9JC22J_IdVZVxQrMc6LF8/https/media.tenor.com/rBKYuya4B-kAAAPo/cat-kiss-yoyo.mp4",
    size: "92px",
    left: "20%",
    top: "8%",
    rotate: "3deg",
    duration: "23s",
    delay: "-7s",
  },
  {
    id: "gif-couple-3",
    type: "video",
    src: "https://images-ext-1.discordapp.net/external/FWNucLFTQpZMd3YyfRxK61eWmb_qOdDSVDcqr0dY1r4/https/media.tenor.com/Vl3j_eCJBEoAAAPo/us-cute-cats.mp4",
    size: "90px",
    left: "42%",
    top: "6%",
    rotate: "-3deg",
    duration: "20s",
    delay: "-9s",
  },
  {
    id: "gif-safado",
    type: "image",
    src: "https://cdn.nekotina.com/images/97PR692R.gif",
    size: "88px",
    left: "88%",
    top: "72%",
    rotate: "4deg",
    duration: "22s",
    delay: "-11s",
  },
  {
    id: "gif-hello",
    type: "video",
    src: "https://images-ext-1.discordapp.net/external/kwZndpzqt3fwxsvTxvM6IC4qhuMUDj8Li_1NBr7UQmY/https/media.tenor.com/zb1Te7_vVucAAAPo/hello.mp4",
    size: "86px",
    left: "8%",
    top: "78%",
    rotate: "-5deg",
    duration: "21s",
    delay: "-6s",
  },
  {
    id: "gif-white-cat-1",
    type: "image",
    src: "https://media.tenor.com/tanvWGxqtTAAAAAM/cat-white-cat.gif",
    size: "76px",
    left: "28%",
    top: "30%",
    rotate: "3deg",
    duration: "19s",
    delay: "-4s",
  },
  {
    id: "gif-white-cat-2",
    type: "image",
    src: "https://media.tenor.com/2Ivc6tbavSIAAAAM/cat-white-cat.gif",
    size: "74px",
    left: "62%",
    top: "24%",
    rotate: "-4deg",
    duration: "21s",
    delay: "-7s",
  },
  {
    id: "gif-cute-couple",
    type: "image",
    src: "https://media.tenor.com/Yep7ctnyXNgAAAAM/cat-couple-cartoon-cute-cartoon-cat-cute.gif",
    size: "82px",
    left: "46%",
    top: "70%",
    rotate: "2deg",
    duration: "22s",
    delay: "-9s",
  },
  {
    id: "gif-falling-stars",
    type: "video",
    src: "https://images-ext-1.discordapp.net/external/3ZQNN2yiMsHQgsFYkqxtCYdBwNtelBOn9W1Ii_BJ8qk/https/media.tenor.com/pAJwQ1fYUCEAAAPo/falling-stars-cute.mp4",
    size: "88px",
    left: "34%",
    top: "14%",
    rotate: "-2deg",
    duration: "20s",
    delay: "-6s",
  },
  {
    id: "gif-stupid-cat",
    type: "video",
    src: "https://media.tenor.com/5-FNjhEQhHIAAAPo/stupid-cat-cat.mp4",
    size: "86px",
    left: "12%",
    top: "56%",
    rotate: "5deg",
    duration: "19s",
    delay: "-3s",
  },
  {
    id: "gif-cute-cat",
    type: "video",
    src: "https://images-ext-1.discordapp.net/external/f_u2KKAs6lRDVFfY090Jm00mDJ00gZ8UjEkU926kBcA/https/media.tenor.com/mcctP8MUbjgAAAPo/cute-cat.mp4",
    size: "86px",
    left: "58%",
    top: "54%",
    rotate: "-3deg",
    duration: "23s",
    delay: "-8s",
  },
  {
    id: "bianca-extra-1",
    type: "image",
    src: "https://media.discordapp.net/attachments/1450288391395475496/1451729161839181825/IMG-20251219-WA0088.jpg?ex=696e1fe4&is=696cce64&hm=97e6893be266b7ce62c1cdb9927ddc2e3e3900b34bf3b5b1b6c63ad98aa811e1&=&format=webp&width=738&height=989",
    size: "120px",
    left: "2%",
    top: "32%",
    rotate: "-6deg",
    duration: "24s",
    delay: "-5s",
    variant: "is-photo",
  },
  {
    id: "bianca-extra-2",
    type: "image",
    src: "https://media.discordapp.net/attachments/1450288391395475496/1450990694272340124/IMG-20251217-WA0037.jpg?ex=696e1323&is=696cc1a3&hm=f898a69ed3eb4ec668d5838e3d5a83c6a466eae4b47129df4092cd3e013425f3&=&format=webp&width=806&height=859",
    size: "116px",
    left: "90%",
    top: "26%",
    rotate: "5deg",
    duration: "22s",
    delay: "-7s",
    variant: "is-photo",
  },
  {
    id: "bianca-extra-3",
    type: "image",
    src: "https://media.discordapp.net/attachments/1450288391395475496/1450990694964531334/IMG-20251217-WA0036.jpg?ex=696e1323&is=696cc1a3&hm=a3e459465f008decefafc49b7840531fc3292552e37a8027caec7f6699cdc361&=&format=webp&width=551&height=858",
    size: "118px",
    left: "80%",
    top: "78%",
    rotate: "-4deg",
    duration: "25s",
    delay: "-9s",
    variant: "is-photo",
  },
];

type FloatRuntime = {
  id: string;
  x: number;
  y: number;
  vx: number;
  vy: number;
  size: number;
  stretchUntil: number;
};

const letterClosedVisiblePx = 140;
const letterOpenHeightPx = 400;
const letterOpenShiftPx = 100;
const letterClipPadPx = 160;
const letterEnvelopeTop = 70.070658;
const letterEnvelopeBottom = 142.187;
const letterViewBoxMinY = 60;
const letterViewBoxHeightBase = 130;
const letterFallbackWidthPx = 600;
const letterClosedVisibleFallbackUnits =
  (letterClosedVisiblePx / letterFallbackWidthPx) * 210;
const letterOpenFallbackUnits =
  (letterOpenHeightPx / letterFallbackWidthPx) * 210;
const relationshipStartDate = new Date(2025, 7, 28, 0, 0, 0);
const letterIntroText =
  "Amorzinho, saiba que você é o motivo de meus risos bobinhos <3 e eu nunca vou me arrepender de ter escolhido você.\n" +
  "e eu espero que você goste disso que preparei para você, sei que pode não ser muito e nem muito bem planejadokkk, mas fiz com carinho<3\n\n";
const letterRestText =
  "\nMeu bem, você não sabe o quanto eu sou apaixonado por você, sério kkk. Eu sou IMENSAMENTE apaixonadinho em você.\n" +
  "Você é uma pessoa incrível, sempre deixa meus dias mais alegres. Os seus áudios bobos me fazem questionar a sua sanidade algumas vezes, mas eu te amo MUITOOO por ser essa pessoa que você é comigo.\n" +
  "Cada dia que passa, mais e mais eu te admiro e amo. Você é uma pessoa simplesmente incrível, foda pra caralho, amor. Eu fico abismado porque literalmente penso assim: \"Omg, minha namorada é foda pra caralho\". " + 
  "Eu te admiro muito, meu amor, muito mesmo, e agradeço muito por você ter me escolhido. Eu prometo que vou fazer tudo possível e impossível para te fazer e te ver feliz <3\n\n" +
  "Eu te amo muito, meu amor.\nDear Rodrigo(o seu Darling<3)";
const letterFullText = `${letterIntroText}${letterRestText}`;

function getElapsedParts(startDate: Date, now: Date) {
  const diffMs = Math.max(now.getTime() - startDate.getTime(), 0);
  const totalHours = Math.floor(diffMs / 3600000);
  return {
    days: Math.floor(totalHours / 24),
    hours: totalHours % 24,
  };
}

function getNextMonthlyAnniversary(startDate: Date, now: Date) {
  const target = new Date(
    now.getFullYear(),
    now.getMonth(),
    startDate.getDate(),
    0,
    0,
    0
  );
  if (now >= target) {
    return new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      startDate.getDate(),
      0,
      0,
      0
    );
  }
  return target;
}

function getCountdownParts(target: Date, now: Date) {
  const diffMs = Math.max(target.getTime() - now.getTime(), 0);
  const totalHours = Math.floor(diffMs / 3600000);
  return {
    days: Math.floor(totalHours / 24),
    hours: totalHours % 24,
  };
}


export function App() {
  const [activeMedia, setActiveMedia] = useState<{
    src: string;
    type: "image" | "video";
  } | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [loginError, setLoginError] = useState<string | null>(null);
  const [floatState, setFloatState] = useState<FloatRuntime[]>([]);
  const [isLetterOpen, setIsLetterOpen] = useState(false);
  const [paperHeight, setPaperHeight] = useState(letterOpenFallbackUnits);
  const [paperTranslatePx, setPaperTranslatePx] = useState(0);
  const [stackOffsetPx, setStackOffsetPx] = useState(0);
  const [stackHeightPx, setStackHeightPx] = useState<number | null>(null);
  const [frontHeightPx, setFrontHeightPx] = useState<number | null>(null);
  const [viewBoxMinY, setViewBoxMinY] = useState(letterViewBoxMinY);
  const [viewBoxHeight, setViewBoxHeight] = useState(letterViewBoxHeightBase);
  const [paperBaseY, setPaperBaseY] = useState(
    letterEnvelopeTop - letterClosedVisibleFallbackUnits
  );
  const [paperClipY, setPaperClipY] = useState(
    letterEnvelopeTop - letterClosedVisibleFallbackUnits
  );
  const [paperClipHeight, setPaperClipHeight] = useState(
    letterEnvelopeBottom - (letterEnvelopeTop - letterClosedVisibleFallbackUnits)
  );
  const [typedBody, setTypedBody] = useState("");
  const [now, setNow] = useState(() => new Date());
  const floatStateRef = useRef<FloatRuntime[]>([]);
  const floatNowRef = useRef(0);
  const paperSvgRef = useRef<SVGSVGElement | null>(null);
  const paperTextRef = useRef<HTMLDivElement | null>(null);
  const paperMeasureRef = useRef<HTMLDivElement | null>(null);
  const paperMeasureOutsideRef = useRef<HTMLDivElement | null>(null);
  const typingIndexRef = useRef(0);
  const typingTimerRef = useRef<number | null>(null);
  const writingAudioRef = useRef<HTMLAudioElement | null>(null);
  const notificationAudioRef = useRef<HTMLAudioElement | null>(null);
  const rawClipId = useId();
  const paperClipId = `paper-clip-${rawClipId.replace(/:/g, "")}`;

  useEffect(() => {
    const audio = new Audio(writingAudio);
    audio.loop = true;
    audio.volume = 0.4;
    audio.preload = "auto";
    writingAudioRef.current = audio;
    return () => {
      audio.pause();
      audio.src = "";
    };
  }, []);

  useEffect(() => {
    const audio = new Audio(notificationAudio);
    audio.preload = "auto";
    audio.volume = 0.6;
    notificationAudioRef.current = audio;
    return () => {
      audio.pause();
      audio.src = "";
    };
  }, []);

  useEffect(() => {
    if (!isLetterOpen) {
      const audio = writingAudioRef.current;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      return;
    }

    typingIndexRef.current = 0;
    setTypedBody("");

    const audio = writingAudioRef.current;
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }

    const step = () => {
      typingIndexRef.current += 1;
      setTypedBody(letterRestText.slice(0, typingIndexRef.current));
      if (typingIndexRef.current >= letterRestText.length) {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
        if (typingTimerRef.current) {
          window.clearInterval(typingTimerRef.current);
          typingTimerRef.current = null;
        }
      }
    };

    typingTimerRef.current = window.setInterval(step, 18);
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      if (typingTimerRef.current) {
        window.clearInterval(typingTimerRef.current);
        typingTimerRef.current = null;
      }
    };
  }, [isLetterOpen]);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(new Date());
    }, 60000);

    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!activeMedia) {
      return;
    }

    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setActiveMedia(null);
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [activeMedia]);

  useEffect(() => {
    const initPositions = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      floatStateRef.current = floatItems.map((item) => {
        const size = Number.parseFloat(item.size);
        const leftPercent = Number.parseFloat(item.left) / 100;
        const topPercent = Number.parseFloat(item.top) / 100;
        const speed = 16 + Math.random() * 22;
        const angle = Math.random() * Math.PI * 2;
        return {
          id: item.id,
          x: leftPercent * width,
          y: topPercent * height,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size,
          stretchUntil: 0,
        };
      });
      setFloatState([...floatStateRef.current]);
    };

    initPositions();
    let raf = 0;
    let last = performance.now();

    const tick = (now: number) => {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      floatNowRef.current = now;
      const width = window.innerWidth;
      const height = window.innerHeight;
      const items = floatStateRef.current;

      for (const item of items) {
        item.x += item.vx * dt;
        item.y += item.vy * dt;

        const wrapX = item.size;
        const wrapY = item.size;
        if (item.x > width + wrapX) item.x = -wrapX;
        if (item.x < -wrapX) item.x = width + wrapX;
        if (item.y > height + wrapY) item.y = -wrapY;
        if (item.y < -wrapY) item.y = height + wrapY;
      }

      for (let i = 0; i < items.length; i += 1) {
        for (let j = i + 1; j < items.length; j += 1) {
          const a = items[i];
          const b = items[j];
          const dx = b.x - a.x;
          const dy = b.y - a.y;
          const dist = Math.hypot(dx, dy);
          const minDist = (a.size + b.size) * 0.48;

          if (dist > 0 && dist < minDist) {
            const nx = dx / dist;
            const ny = dy / dist;
            const overlap = minDist - dist;

            a.x -= nx * (overlap / 2);
            a.y -= ny * (overlap / 2);
            b.x += nx * (overlap / 2);
            b.y += ny * (overlap / 2);

            const tempVx = a.vx;
            const tempVy = a.vy;
            a.vx = b.vx;
            a.vy = b.vy;
            b.vx = tempVx;
            b.vy = tempVy;

            a.stretchUntil = now + 160;
            b.stretchUntil = now + 160;
          }
        }
      }

      setFloatState([...items]);
      raf = window.requestAnimationFrame(tick);
    };

    raf = window.requestAnimationFrame(tick);
    window.addEventListener("resize", initPositions);
    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener("resize", initPositions);
    };
  }, []);

  const floatMap = useMemo(() => {
    const map = new Map<string, FloatRuntime>();
    for (const item of floatState) {
      map.set(item.id, item);
    }
    return map;
  }, [floatState]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const updatePaperMetrics = () => {
      const svg = paperSvgRef.current;
      if (!svg) {
        return;
      }

      const svgRect = svg.getBoundingClientRect();
      if (!svgRect.width) {
        return;
      }

      const pxPerUnit = svgRect.width / 210;
      const openHeightUnits = letterOpenHeightPx / pxPerUnit;
      const closedVisibleUnits = letterClosedVisiblePx / pxPerUnit;
      const openShiftUnits = letterOpenShiftPx / pxPerUnit;
      const openVisibleUnits = Math.min(
        openHeightUnits,
        closedVisibleUnits + openShiftUnits
      );
      const visibleUnits = isLetterOpen ? openVisibleUnits : closedVisibleUnits;
      const nextBaseY = letterEnvelopeTop - closedVisibleUnits;
      const clipPadUnits = isLetterOpen ? letterClipPadPx / pxPerUnit : 0;
      const nextClipTop = letterEnvelopeTop - visibleUnits - clipPadUnits;
      const nextClipHeight = letterEnvelopeBottom - nextClipTop;
      const nextViewBoxMinY = Math.min(letterViewBoxMinY, nextClipTop);
      const nextViewBoxHeight = letterEnvelopeBottom - nextViewBoxMinY;

      setPaperHeight(openHeightUnits);
      setPaperBaseY(nextBaseY);
      setPaperClipY(nextClipTop);
      setPaperClipHeight(nextClipHeight);
      setPaperTranslatePx(isLetterOpen ? -letterOpenShiftPx : 0);
      setViewBoxMinY(nextViewBoxMinY);
      setViewBoxHeight(nextViewBoxHeight);
      setStackHeightPx(nextViewBoxHeight * pxPerUnit);
      setFrontHeightPx(nextViewBoxHeight * pxPerUnit);
      setStackOffsetPx(0);
    };

    const svgEl = paperSvgRef.current;
    if (!svgEl) {
      return;
    }

    updatePaperMetrics();
    if (document.fonts?.ready) {
      document.fonts.ready.then(updatePaperMetrics).catch(() => {});
    }

    const resizeObserver = new ResizeObserver(updatePaperMetrics);
    resizeObserver.observe(svgEl);

    window.addEventListener("resize", updatePaperMetrics);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updatePaperMetrics);
    };
  }, [isLetterOpen, isAuthenticated]);

  const handleLetterClick = () => {
    setIsLetterOpen((prev) => !prev);
    if (isLetterOpen) {
      setTypedBody("");
    }
  };

  const paperY = paperBaseY;

  const handleLoginSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = passwordInput.trim();
    if (trimmed === "28082025") {
      setIsAuthenticated(true);
      setLoginError(null);
      setPasswordInput("");
      const audio = notificationAudioRef.current;
      if (audio) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
      }
      return;
    }
    if (trimmed === "21122006") {
      setLoginError("foi quase, bobinha");
      return;
    }
    setLoginError("senha incorreta");
  };

  const { togetherDays, togetherHours, nextDays, nextHours } = useMemo(() => {
    const elapsed = getElapsedParts(relationshipStartDate, now);
    const nextSpecialDate = getNextMonthlyAnniversary(
      relationshipStartDate,
      now
    );
    const remaining = getCountdownParts(nextSpecialDate, now);
    return {
      togetherDays: elapsed.days,
      togetherHours: elapsed.hours,
      nextDays: remaining.days,
      nextHours: remaining.hours,
    };
  }, [now]);

  if (!isAuthenticated) {
    return (
      <div className="page login-page">
        <div className="login-card">
          <h1>Adivinha a senha</h1>
          <p className="login-subtitle">Tem duas senhas :3 uma é a certa a outra um easter egg</p>
          <form className="login-form" onSubmit={handleLoginSubmit}>
            <input
              className="login-input"
              type="password"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="Senha"
              value={passwordInput}
              onChange={(event) => {
                setPasswordInput(event.target.value);
                if (loginError) {
                  setLoginError(null);
                }
              }}
            />
            <button className="login-button" type="submit">
              Entrar
            </button>
          </form>
          {loginError ? (
            <p className="login-error" role="alert">
              {loginError}
            </p>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="relationship-counter" aria-hidden="true">
        <p className="counter-label">Estamos juntos a</p>
        <p className="counter-value">
          {togetherDays} dias, {togetherHours} horas
        </p>
        <p className="counter-subline">
          Faltam {nextDays} dias e {nextHours} horas para nós completarmos mais
          1 mês juntos
        </p>
      </div>
      <div className="particles" aria-hidden="true">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="cat-particle"
            style={
              {
                "--size": particle.size,
                "--left": particle.left,
                "--top": particle.top,
                "--duration": particle.duration,
                "--delay": particle.delay,
                "--drift": particle.drift,
                "--rotate": particle.rotate,
                "--opacity": particle.opacity,
              } as CSSProperties
            }
          >
            <img src={particle.src} alt="" />
          </div>
        ))}
      </div>

      <div className="float-gallery" aria-hidden="true">
        {floatItems.map((item) => {
          const runtime = floatMap.get(item.id);
          const stretch = runtime
            ? runtime.stretchUntil > floatNowRef.current
            : false;
          const isClickable = item.type === "image" || item.type === "video";
          const WrapperTag = isClickable ? "button" : "div";
          return (
            <WrapperTag
              key={item.id}
              className={`float-item ${item.variant ?? ""} ${
                isClickable ? "is-clickable" : ""
              }`}
              type={isClickable ? "button" : undefined}
              onClick={
                isClickable
                  ? () => {
                      setActiveMedia({
                        src: item.src,
                        type: item.type,
                      });
                    }
                  : undefined
              }
              style={
                {
                  width: item.size,
                  transform: runtime
                    ? `translate3d(${runtime.x}px, ${runtime.y}px, 0) rotate(${item.rotate}) scale(${stretch ? 1.08 : 1}, ${stretch ? 0.92 : 1})`
                    : `translate3d(0, 0, 0) rotate(${item.rotate})`,
                } as CSSProperties
              }
            >
              {item.type === "video" ? (
                <video
                  src={item.src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                />
              ) : (
                <img src={item.src} alt="" />
              )}
            </WrapperTag>
          );
        })}
      </div>

      {activeMedia ? (
        <div className="image-modal" role="dialog" aria-modal="true">
          <button
            type="button"
            className="image-modal-backdrop"
            aria-label="Fechar imagem"
            onClick={() => setActiveMedia(null)}
          />
          <div className="image-modal-card">
            {activeMedia.type === "video" ? (
              <video
                src={activeMedia.src}
                autoPlay
                loop
                muted
                playsInline
                controls
              />
            ) : (
              <img src={activeMedia.src} alt="" />
            )}
            <button
              type="button"
              className="image-modal-close"
              onClick={() => setActiveMedia(null)}
            >
              Fechar
            </button>
          </div>
        </div>
      ) : null}

      <main className="content">
        <div
          className="letter-wrap"
          style={{ transform: `translateY(${stackOffsetPx}px)` }}
        >
          <section className={`letter ${isLetterOpen ? "is-open" : ""}`}>
            <button
              type="button"
              className="letter-toggle"
              onClick={handleLetterClick}
              aria-pressed={isLetterOpen}
              aria-label="Abrir ou fechar a carta"
            >
              <div
                className="letter-stack"
                style={
                  stackHeightPx
                    ? { height: `${stackHeightPx}px` }
                    : { aspectRatio: `210 / ${letterViewBoxHeightBase}` }
                }
              >
                <svg
                  className="letter-svg letter-back"
                  viewBox={`0 ${viewBoxMinY} 210 ${viewBoxHeight}`}
                  role="img"
                  aria-hidden="true"
                  ref={paperSvgRef}
                  style={
                    stackHeightPx
                      ? { height: `${stackHeightPx}px` }
                      : undefined
                  }
                >
                  <defs>
                    <clipPath id={paperClipId} clipPathUnits="userSpaceOnUse">
                      <rect
                        className="letter-clip-rect"
                        x="38.827007"
                        y={paperClipY}
                        width="140.30428"
                        height={paperClipHeight}
                      />
                    </clipPath>
                  </defs>
                  <g clipPath={`url(#${paperClipId})`}>
                    <g
                      className="letter-paper-group"
                      style={{ transform: `translateY(${paperTranslatePx}px)` }}
                    >
                      <rect
                        className="letter-paper"
                        width="140.30428"
                        height={paperHeight}
                        x="38.827007"
                        y={paperY}
                        ry="3.2824175"
                        fill="#ffffff"
                        stroke="#ebe6e6"
                        strokeWidth="0.364"
                      />
                      <foreignObject
                        x="38.827007"
                        y={paperY}
                        width="140.30428"
                        height={paperHeight}
                      >
                        <div
                          className="letter-fo"
                          xmlns="http://www.w3.org/1999/xhtml"
                        >
                          <div className="letter-text" ref={paperTextRef}>
                            <h2>Para meu amorzinho</h2>
                            <p className="letter-body">
                              <span className="letter-intro">
                                {letterIntroText}
                              </span>
                              <span className="letter-typed">{typedBody}</span>
                            </p>
                            <div
                              className="letter-measure"
                              ref={paperMeasureRef}
                              aria-hidden="true"
                            >
                              <h2>Para meu amorzinho</h2>
                              <p className="letter-body">{letterFullText}</p>
                            </div>
                          </div>
                        </div>
                      </foreignObject>
                    </g>
                  </g>
                </svg>

                <svg
                  className="letter-svg letter-front"
                  viewBox={`0 ${viewBoxMinY} 210 ${viewBoxHeight}`}
                  role="img"
                  aria-hidden="true"
                  style={
                    frontHeightPx
                      ? { height: `${frontHeightPx}px`, top: "auto", bottom: 0 }
                      : { top: "auto", bottom: 0 }
                  }
                >
                  <path
                    d="m 181.4158,70.070658 c -0.0144,7.83e-4 -0.0278,0.004 -0.0403,0.0098 L 108.83677,103.696 36.905758,70.080477 c -0.157499,-0.07579 -0.610816,0.521915 -0.610816,1.013375 v 71.093338 c 0,1.34741 1.084996,2.43241 2.43241,2.43241 H 179.60506 c 1.34741,0 2.43241,-1.085 2.43241,-2.43241 V 71.093852 c 0,-0.501607 -0.40598,-1.034932 -0.62167,-1.023194 z m -80.09227,33.756082 c 4.72726,-0.15179 7.58076,5.81226 7.73803,6.14898 0.13044,-0.27392 3.00414,-6.19151 7.75612,-6.03891 1.62151,0.0521 3.46391,0.82373 5.4932,2.78898 6.46925,6.26511 -2.8881,11.3068 -7.79229,15.6993 -4.54049,4.06674 -5.45135,8.81354 -5.45135,10.09137 v -0.17415 c -0.002,-0.0154 -0.90949,-5.96633 -5.44411,-10.02781 -4.90419,-4.3925 -14.261537,-9.43368 -7.792287,-15.69879 2.029296,-1.96525 3.871178,-2.73687 5.492687,-2.78897 z"
                    fill="#ede8d0"
                    stroke="#635823"
                    strokeWidth="1.165"
                  />
                </svg>
              </div>
            </button>
          </section>
        </div>

        <div
          className="letter-measure-outside letter-text"
          ref={paperMeasureOutsideRef}
          aria-hidden="true"
        >
          <h2>Minha carta para voce</h2>
          <p className="letter-body">{letterFullText}</p>
        </div>

        <div className="spotify-player">
          <iframe
            title="Spotify playlist"
            src="https://open.spotify.com/embed/playlist/1Wfl7sntt5LSofGGPbiuaC?utm_source=generator"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          />
        </div>
      </main>
    </div>
  );
}

export default App;
